const languages = [
  {
    code: 'en',
    name: 'English',
    countryCode: 'us',
  },
  {
    code: 'es',
    name: 'Espanol',
    countryCode: 'es',
  },
  // {
  //   code: 'fr',
  //   name: 'Francais',
  //   countryCode: 'fr',
  // },
];

export default languages;
